import { Task } from '@griply/types';
import { DeletedFilter } from '@griply/utils';
import { useTasksQuery } from 'shared/hooks/queries/use-tasks-query';
import { useUser } from 'shared/hooks/use-user';
import { GetTaskOptions } from 'shared/services/backend-api';
import { TaskType } from 'shared/types/task-base';

// Fallthrough for options carrying a server-only constraint (ids / date windows):
// those cannot be derived from the base subscription, so they keep their own
// per-options listener. `enabled` keeps it inert (no listener at all) whenever the
// derived path is used instead.
export const useLegacyTasksOfType = (
  type: TaskType,
  options: Omit<GetTaskOptions, 'type'>,
  deletedFilter: DeletedFilter,
  enabled: boolean,
): Task[] => {
  const user = useUser();
  const { data } = useTasksQuery(user?.uid, { ...options, type }, enabled, {
    deletedFilter,
  });

  return data ?? [];
};
